import segment from '@flipster/utils/segment';
import { TradeEvent } from '@flipster/utils/segment/events/trade';
import { V2OrderSideType } from '@flipster/utils/types/base';

interface TimeTriggerTpslSettingProps {
  symbol: string;
  side: V2OrderSideType;
  initLeverage?: number;
  tpSlType: 'tp' | 'sl';
  amount?: string;
  qty?: string;
  triggerTimestamp: string;
  triggerPriceRatio?: string;
}

interface TimeTriggerTpslConfirmProps extends TimeTriggerTpslSettingProps {
  currentPriceRatio: string;
  estimatedPnl: string;
}

export const pendingTimeTriggerTpslSettingClickEvent = (t: TimeTriggerTpslSettingProps) => {
  segment.track(TradeEvent.PendingTimeTriggerTpslSettingClick, {
    symbol: t.symbol,
    side: t.side === 'Long' ? 'buy' : 'sell',
    leverage: t.initLeverage ?? 1,
    tpsl_type: t.tpSlType === 'tp' ? 'Take Profit' : 'Stop Loss',
    trigger_time: t.triggerTimestamp,
    trigger_price_ratio: t.triggerPriceRatio,
    amount_usdt: t.amount,
    quantity: t.qty,
  });
};

export const pendingTimeTriggerTpslConfirmClickEvent = (t: TimeTriggerTpslConfirmProps) => {
  segment.track(TradeEvent.PendingTimeTriggerTpslConfirmClick, {
    symbol: t.symbol,
    position: t.side === 'Long' ? 'buy' : 'sell',
    leverage: t.initLeverage ?? 1,
    tpsl_type: t.tpSlType === 'tp' ? 'Take Profit' : 'Stop Loss',
    trigger_time: t.triggerTimestamp,
    trigger_price_ratio: t.triggerPriceRatio,
    amount_usdt: t.amount,
    quantity: t.qty,
    current_price: t.currentPriceRatio,
    estimated_pnl: t.estimatedPnl,
  });
};

export const pendingTimeTriggerTpslDeleteClickEvent = (t: Omit<TimeTriggerTpslSettingProps, 'leverage'>) => {
  segment.track(TradeEvent.PendingTimeTriggerTpslDeleteClick, {
    symbol: t.symbol,
    side: t.side === 'Long' ? 'buy' : 'sell',
    tpsl_type: t.tpSlType === 'tp' ? 'Take Profit' : 'Stop Loss',
    trigger_time: t.triggerTimestamp,
    trigger_price_ratio: t.triggerPriceRatio,
    amount_usdt: t.amount,
    quantity: t.qty,
  });
};

export const pendingTimeTriggerTpslDeleteConfirmClickEvent = (t: Omit<TimeTriggerTpslSettingProps, 'leverage'>) => {
  segment.track(TradeEvent.PendingTimeTriggerTpslDeleteClick, {
    symbol: t.symbol,
    side: t.side === 'Long' ? 'buy' : 'sell',
    tpsl_type: t.tpSlType === 'tp' ? 'Take Profit' : 'Stop Loss',
    trigger_time: t.triggerTimestamp,
    trigger_price_ratio: t.triggerPriceRatio,
    amount_usdt: t.amount,
    quantity: t.qty,
  });
};
